<template>
  <div class="footers">
    <div class="bottom_list"></div>
    <!-- &copy; 2023 中文百科数据集团有限公司 -->
  </div>
</template>
<script>
export default {
  name: "footers",

  components: {},
  mounted() { },
};
</script>
<style scoped>
.bottom_list {
  width: 100%;
  background: #132466;
  height: 60px;
  line-height: 60px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: flex;
  left: 0px;
  bottom: 0px;
}
</style>
